import Image from 'next/image';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Dialog from '@alltrails/denali/components/Dialog';
import headToTheAppQrCode from './head-to-the-app-qr-code.svg';
import styles from './HeadToTheAppDialog.module.scss';

type Props = {
  href?: string;
  onCloseRequest: () => void;
  provider: 'apple' | 'google';
  text: ReactNode; // Maybe later or Get back to exploring
};

const body: Record<Props['provider'], ReactNode> = {
  apple: <FormattedMessage defaultMessage="You’re subscribed with Apple. Scan the QR code to upgrade on your phone." />,
  google: <FormattedMessage defaultMessage="You’re subscribed with Google. Scan the QR code to upgrade on your phone." />
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=10314-22342&m=dev
export default function HeadToTheAppDesktopDialog({ href, onCloseRequest, provider, text }: Props) {
  const intl = useIntl();

  return (
    <Dialog
      body={body[provider]}
      buttons={{
        default: {
          ...(href && { linkInfo: { href } }),
          onClick: () => {
            onCloseRequest();
          },
          text,
          testId: 'maybe-later'
        }
      }}
      icon={
        <Image
          alt={intl.formatMessage({
            defaultMessage:
              'This QR code is intended to scan from a smartphone. If you have the AllTrails app, the link will open the app for you. If you don’t have the app, the link will take you to your device’s app store.'
          })}
          className={styles.qr}
          src={headToTheAppQrCode}
        />
      }
      onRequestClose={onCloseRequest}
      overlayClassName={styles.overlay}
      title={<FormattedMessage defaultMessage="Head to the app" />}
    />
  );
}
